import React from "react";
import TR808Drum, { DrumTime } from "../../../audio/instruments/TR808Drum";
import {
    DrumPadGroup
} from "./DrumKit";
import {
    GaugeControl,
    TriggerPad
} from "./Common";
import { RydToggleButton } from "../../widgets/RydToggleButton";


export function TrAcht({
    drum,
    showTriggerPads = false
}: {
    drum: TR808Drum,
    showTriggerPads?: boolean
}) {
    const [triggerPadsVisible, setTriggerPadsVisible] = React.useState(showTriggerPads);

    return (
        <div style={{ padding: '2px' }} className='ryd-instrument-wrapper'>
            <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
                <DrumPadGroup name="Input">
                    {triggerPadsVisible && <div className="ryd--trigger-pad--spacer" />}
                    <GaugeControl min={-36} max={36} value={0 | drum.inputPitchShiftSemitones} label="Pitch shift (semitones)"
                        update={(v) => {
                            // FIXME: make this increase in steps of 1 on the UI side
                            drum.inputPitchShiftSemitones = 0 | v;
                        }}
                    />
                    <RydToggleButton
                        active={triggerPadsVisible}
                        onActivate={() => setTriggerPadsVisible(true)}
                        onDeactivate={() => setTriggerPadsVisible(false)}
                        activeStyle={{
                            backgroundColor: 'orange',
                        }}
                    >Pads</RydToggleButton>

                </DrumPadGroup>
                <DrumPadGroup name="Kick">
                    {triggerPadsVisible && <TriggerPad
                        trigger={(t?: DrumTime) => drum.triggerKick(t)}
                    />}
                    <GaugeControl label="Volume" value={drum.cfg.kick.volume}
                        update={(v) => {
                            drum.updateVoiceSettings({ kick: { ...drum.cfg.kick, volume: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Decay"
                        value={drum.cfg.kick.decay}
                        update={(v) => {
                            drum.updateVoiceSettings({ kick: { ...drum.cfg.kick, decay: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Tone"
                        value={drum.cfg.kick.toneHz}
                        update={(v) => {
                            drum.updateVoiceSettings({ kick: { ...drum.cfg.kick, toneHz: v } });
                        }}
                        min={0}
                        max={80}
                    />
                    <GaugeControl label="Pitch decay"
                        value={drum.cfg.kick.pitchDecay}
                        update={(v) => {
                            drum.updateVoiceSettings({ kick: { ...drum.cfg.kick, pitchDecay: v } });
                        }}
                        min={0}
                        max={1}
                    />
                </DrumPadGroup>
                <DrumPadGroup name="Snare">
                    {triggerPadsVisible && <TriggerPad
                        trigger={(t?: DrumTime) => drum.triggerSnare(t)}
                    />}
                    <GaugeControl label="Volume"
                        value={drum.cfg.snare.volume}
                        update={(v) => {
                            drum.updateVoiceSettings({ snare: { ...drum.cfg.snare, volume: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Decay"
                        value={drum.cfg.snare.decay}
                        update={(v) => {
                            drum.updateVoiceSettings({ snare: { ...drum.cfg.snare, decay: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Tone"
                        value={drum.cfg.snare.toneHz}
                        update={(v) => {
                            drum.updateVoiceSettings({ snare: { ...drum.cfg.snare, toneHz: v } });
                        }}
                        min={80}
                        max={360}
                    />
                </DrumPadGroup>
                <DrumPadGroup name="Rim">
                    {triggerPadsVisible && <TriggerPad
                        trigger={(t?: DrumTime) => drum.triggerRim(t)}
                    />}
                    <GaugeControl label="Volume"
                        value={drum.cfg.rim.volume}
                        update={(v) => {
                            drum.updateVoiceSettings({ rim: { ...drum.cfg.rim, volume: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Decay"
                        value={drum.cfg.rim.decay}
                        update={(v) => {
                            drum.updateVoiceSettings({ rim: { ...drum.cfg.rim, decay: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Tone"
                        value={drum.cfg.rim.toneHz}
                        update={(v) => {
                            drum.updateVoiceSettings({ rim: { ...drum.cfg.rim, toneHz: v } });
                        }}
                        min={80}
                        max={360}
                    />
                </DrumPadGroup>
                <DrumPadGroup name="C-Hat">
                    {triggerPadsVisible && <TriggerPad
                        trigger={(t?: DrumTime) => drum.triggerClosedHat(t)}
                    />}
                    <GaugeControl label="Volume"
                        value={drum.cfg.ch.volume}
                        update={(v) => {
                            drum.updateVoiceSettings({ ch: { ...drum.cfg.ch, volume: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Decay"
                        value={drum.cfg.ch.decay}
                        update={(v) => {
                            drum.updateVoiceSettings({ ch: { ...drum.cfg.ch, decay: v } });
                        }}
                        min={0}
                        max={0.3}
                    />
                    <GaugeControl label="Tone"
                        value={drum.cfg.ch.toneHz}
                        update={(v) => {
                            drum.updateVoiceSettings({ ch: { ...drum.cfg.ch, toneHz: v } });
                        }}
                        min={2000}
                        max={6000}
                    />
                </DrumPadGroup>
                <DrumPadGroup name="O-Hat" >
                    {triggerPadsVisible && <TriggerPad
                        trigger={(t?: DrumTime) => drum.triggerOpenHat(t)}
                    />}
                    <GaugeControl label="Volume"
                        value={drum.cfg.oh.volume}
                        update={(v) => {
                            drum.updateVoiceSettings({ oh: { ...drum.cfg.oh, volume: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Decay"
                        value={drum.cfg.oh.decay}
                        update={(v) => {
                            drum.updateVoiceSettings({ oh: { ...drum.cfg.oh, decay: v } });
                        }}
                        min={0.1}
                        max={1.3}
                    />
                    <GaugeControl label="Tone"
                        value={drum.cfg.oh.toneHz}
                        update={(v) => {
                            drum.updateVoiceSettings({ oh: { ...drum.cfg.oh, toneHz: v } });
                        }}
                        min={2000}
                        max={6000}
                    />
                </DrumPadGroup>
                <DrumPadGroup name="L-Tom">
                    {triggerPadsVisible && <TriggerPad
                        trigger={(t?: DrumTime) => drum.triggerLowTom(t)}
                    />}
                    <GaugeControl label="Volume"
                        value={drum.cfg.lt.volume}
                        update={(v) => {
                            drum.updateVoiceSettings({ lt: { ...drum.cfg.lt, volume: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Decay"
                        value={drum.cfg.lt.decay}
                        update={(v) => {
                            drum.updateVoiceSettings({ lt: { ...drum.cfg.lt, decay: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Tone"
                        value={drum.cfg.lt.toneHz}
                        update={(v) => {
                            drum.updateVoiceSettings({ lt: { ...drum.cfg.lt, toneHz: v } });
                        }}
                        min={60}
                        max={180}
                    />
                </DrumPadGroup>
                <DrumPadGroup name="M-Tom" >
                    {triggerPadsVisible && <TriggerPad
                        trigger={(t?: DrumTime) => drum.triggerMidTom(t)}
                    />}
                    <GaugeControl label="Volume"
                        value={drum.cfg.mt.volume}
                        update={(v) => {
                            drum.updateVoiceSettings({ mt: { ...drum.cfg.mt, volume: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Decay"
                        value={drum.cfg.mt.decay}
                        update={(v) => {
                            drum.updateVoiceSettings({ mt: { ...drum.cfg.mt, decay: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Tone"
                        value={drum.cfg.mt.toneHz}
                        update={(v) => {
                            drum.updateVoiceSettings({ mt: { ...drum.cfg.mt, toneHz: v } });
                        }}
                        min={90}
                        max={240}
                    />
                </DrumPadGroup>
                <DrumPadGroup name="H-Tom" >
                    {triggerPadsVisible && <TriggerPad
                        trigger={(t?: DrumTime) => drum.triggerHighTom(t)}
                    />}
                    <GaugeControl label="Volume"
                        value={drum.cfg.ht.volume}
                        update={(v) => {
                            drum.updateVoiceSettings({ ht: { ...drum.cfg.ht, volume: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Decay"
                        value={drum.cfg.ht.decay}
                        update={(v) => {
                            drum.updateVoiceSettings({ ht: { ...drum.cfg.ht, decay: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Tone"
                        value={drum.cfg.ht.toneHz}
                        update={(v) => {
                            drum.updateVoiceSettings({ ht: { ...drum.cfg.ht, toneHz: v } });
                        }}
                        min={100}
                        max={300}
                    />
                </DrumPadGroup>
                <DrumPadGroup name="Clap" >
                    {triggerPadsVisible && <TriggerPad
                        trigger={(t?: DrumTime) => drum.triggerClap(t)}
                    />}
                    <GaugeControl label="Volume"
                        value={drum.cfg.clap.volume}
                        update={(v) => {
                            drum.updateVoiceSettings({ clap: { ...drum.cfg.clap, volume: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Decay"
                        value={drum.cfg.clap.decay}
                        update={(v) => {
                            drum.updateVoiceSettings({ clap: { ...drum.cfg.clap, decay: v } });
                        }}
                        min={0}
                        max={10}
                    />
                    <GaugeControl label="Spread"
                        value={drum.cfg.clap.spread}
                        update={(v) => {
                            drum.updateVoiceSettings({ clap: { ...drum.cfg.clap, spread: v } });
                        }}
                        min={0}
                        max={0.08}
                    />
                </DrumPadGroup>
                <DrumPadGroup name="Cymbal" >
                    {triggerPadsVisible && <TriggerPad
                        trigger={(t?: DrumTime) => drum.triggerCymbal(t)}
                    />}
                    <GaugeControl label="Volume"
                        value={drum.cfg.cy.volume}
                        update={(v) => {
                            drum.updateVoiceSettings({ cy: { ...drum.cfg.cy, volume: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Decay"
                        value={drum.cfg.cy.decay}
                        update={(v) => {
                            drum.updateVoiceSettings({ cy: { ...drum.cfg.cy, decay: v } });
                        }}
                        min={0}
                        max={3}
                    />
                    <GaugeControl label="Tone"
                        value={drum.cfg.cy.toneHz}
                        update={(v) => {
                            drum.updateVoiceSettings({ cy: { ...drum.cfg.cy, toneHz: v } });
                        }}
                        min={2000}
                        max={8000}
                    />
                </DrumPadGroup>
                <DrumPadGroup name="Cowbell" >
                    {triggerPadsVisible && <TriggerPad
                        trigger={(t?: DrumTime) => drum.triggerCowbell(t)}
                    />}
                    <GaugeControl label="Volume"
                        value={drum.cfg.cowbell.volume}
                        update={(v) => {
                            drum.updateVoiceSettings({ cowbell: { ...drum.cfg.cowbell, volume: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Decay"
                        value={drum.cfg.cowbell.decay}
                        update={(v) => {
                            drum.updateVoiceSettings({ cowbell: { ...drum.cfg.cowbell, decay: v } });
                        }}
                        min={0}
                        max={1}
                    />
                    <GaugeControl label="Tone"
                        value={drum.cfg.cowbell.toneHz}
                        update={(v) => {
                            drum.updateVoiceSettings({ cowbell: { ...drum.cfg.cowbell, toneHz: v } });
                        }}
                        min={200}
                        max={800}
                    />
                </DrumPadGroup>
            </div>
        </div>
    );
}